import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { NotificationsStore } from '@shure/cloud/shared/notifications/notifications-store';
import { NotificationStoreData } from '@shure/cloud/shared/notifications/shared/models/notification-models';

import { PostNotifications$Params } from '../_AUTOGENERATED_/fn/notification-api-message-center/post-notifications';

import { NotificationsApiService } from './notifications-api.service';

@Injectable({
	providedIn: 'root'
})
export class NotificationsService {
	constructor(
		private notificationApiService: NotificationsApiService,
		private notificationsStore: NotificationsStore
	) {}

	public markAsArchive(
		requestData: PostNotifications$Params,
		updatedNotifications: Array<Pick<NotificationStoreData, 'id'> & Partial<NotificationStoreData>>
	): Observable<unknown> {
		return this.notificationApiService.postNotifications(requestData).pipe(
			tap(() => {
				this.notificationsStore.prependOrPatchNotifications(updatedNotifications);
			})
		);
	}

	public markAsRead(requestData: PostNotifications$Params): Observable<unknown> {
		return this.notificationApiService.postNotifications(requestData);
	}

	public markAsTrash(
		requestData: PostNotifications$Params,
		notification: NotificationStoreData
	): Observable<unknown> {
		return this.notificationApiService.postNotifications(requestData).pipe(
			tap(() => {
				this.notificationsStore.prependOrPatchNotifications([notification]);
			})
		);
	}

	/**
	 * Generates the current UTC timestamp.
	 * A small offset is added to ensure timestamp consistency
	 * during immediate state updates.
	 *
	 * @returns UTC timestamp in ISO 8601 format.
	 */
	public getCurrentDateInUTC(): string {
		const currentDate = new Date(new Date().getTime() + 10000);
		return currentDate.toISOString().slice(0, 19) + 'Z';
	}
}
